import QsehraCompanyAddress from './QsehraCompanyAddress'
import QsehraCompanyName from './QsehraCompanyName'
import QsehraPhoneNumber from './QsehraPhoneNumber'

export default {
  QsehraCompanyAddress,
  QsehraCompanyName,
  QsehraPhoneNumber,
}
